export const checkPermission = (permission, configuration) => {
  const permissions = configuration?.auth?.grantedPolicies
  if (!permission) return true
  if (permission.indexOf('.*') >= 0) {
    const perHead = permission.replace('*', '')
    for (const key in permissions) {
      if (key.indexOf(perHead) == 0) {
        return true
      }
    }
    return false
  }
  if (!permissions) return false
  return permission in permissions && permissions[permission]
}
